import { styled } from 'styled-components';

import {
  createResponsiveSpacingStyle,
  DefaultIconProps,
  DefaultIconWrapper,
  getSemanticTextColor,
  ResponsiveSpacing,
} from '../../../utils';

const AnimatedSpinnerSvg = styled('svg')<{ strokeWidthResponsive: ResponsiveSpacing; iconHeight: ResponsiveSpacing }>`
  box-sizing: border-box;
  overflow: visible;
  ${props => props.iconHeight && createResponsiveSpacingStyle('height', props.iconHeight)};
  circle {
    ${props =>
      props.strokeWidthResponsive && `${createResponsiveSpacingStyle('stroke-width', props.strokeWidthResponsive)}`};
    fill: none;
    cx: 50%;
    cy: 50%;
    r: 50%;
    stroke-linecap: round;
    transform-origin: center;
  }
`;

type SpinnerProps = DefaultIconProps & {
  center?: boolean;
  variant?: 'slim' | 'fat';
  strokeWidth?: ResponsiveSpacing;
};

export const Spinner = ({
  width = 100,
  strokeWidth = 2,
  marginTop = 0,
  marginBottom = 0,
  marginLeft,
  marginRight,
  color = 'foraBlue',
}: SpinnerProps) => {
  return (
    <DefaultIconWrapper
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginRight={marginRight}
      marginLeft={marginLeft}
      width={width}
    >
      <AnimatedSpinnerSvg strokeWidthResponsive={strokeWidth} iconHeight={width}>
        <circle stroke={getSemanticTextColor(color)}>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="-90;810"
            keyTimes="0;1"
            dur="2.5s"
            repeatCount="indefinite"
          ></animateTransform>
          <animate
            attributeName="stroke-dashoffset"
            values="0%;0%;-157.080%"
            calcMode="spline"
            keySplines="0.61, 1, 0.88, 1; 0.12, 0, 0.39, 0"
            keyTimes="0;0.5;1"
            dur="2.5s"
            repeatCount="indefinite"
          ></animate>
          <animate
            attributeName="stroke-dasharray"
            values="0% 314.159%;157.080% 157.080%;0% 314.159%"
            calcMode="spline"
            keySplines="0.61, 1, 0.88, 1; 0.12, 0, 0.39, 0"
            keyTimes="0;0.5;1"
            dur="2.5s"
            repeatCount="indefinite"
          ></animate>
        </circle>
      </AnimatedSpinnerSvg>
    </DefaultIconWrapper>
  );
};
